import { Component } from '@angular/core';

import { NavController, NavParams } from 'ionic-angular';

import { LoginPage } from '../login/login';
import { User } from '../../providers/user';
import { UserData } from '../../providers/user-data';
import { ApiService } from '../../api-service/api-service';

declare var AWS: any;

@Component({
  selector: 'page-confirm',
  templateUrl: 'confirm.html'
})
export class ConfirmPage {
  
  public code: string;
  public username: string;
  public sub: string = null;

  constructor(public navCtrl: NavController, public navParams: NavParams, public user: User, public server:ApiService, public userData:UserData) {
    this.username = navParams.get('username');
  }

  confirm() {
    this.user.confirmRegistration(this.username, this.code).then(() => {
      this.sub = AWS.config.credentials.identityId;
      let avatarKey = 'protected/' + this.sub + '/avatar';
      this.userData.avatarKey = avatarKey;
      this.server.updateUserData(this.userData.avatarKey,this.logErrorCallback);
      //this.server.UpdateAvatarKey(this.logErrorCallback,avatarKey);
      this.navCtrl.push(LoginPage);
    });
  }

  resendCode() {
    this.user.resendRegistrationCode(this.username);
  }

  logErrorCallback = (data) => {
    this.logError(data);
  }

  logError(data){
    console.error("Error setting default avatar for "+this.username);
  }


}



// WEBPACK FOOTER //
// ./src/pages/confirm/confirm.ts